import { Link as MuiLink } from '@mui/material';

import { formatPhone } from '../lib/contact';

/** A phone number to tap and call, or a dash. */
export function PhoneLink({ phone }: { phone: string | null }) {
  return phone ? <MuiLink href={`tel:${phone}`}>{formatPhone(phone)}</MuiLink> : <>–</>;
}

/** An email address to click and write to, or a dash. */
export function EmailLink({ email }: { email: string | null }) {
  return email ? <MuiLink href={`mailto:${email}`}>{email}</MuiLink> : <>–</>;
}
